(() => {
  const SELECTOR = '.form-field--conditional';

  const getControlValue = (name) => {
    const nodes = document.querySelectorAll(`[name="${CSS.escape(name)}"]`);
    if (!nodes.length) return '';
    const first = nodes[0];
    if (first.type === 'radio' || first.type === 'checkbox') {
      const checked = Array.from(nodes).find((n) => n.checked);
      return checked ? checked.value : '';
    }
    return first.value || '';
  };

  const evaluate = (field) => {
    const depName = field.getAttribute('data-field-depends-on-name');
    const depValue = field.getAttribute('data-field-depends-on-value');
    if (!depName) return;
    const current = getControlValue(depName);
    const matches = current === depValue;
    field.classList.toggle('is-hidden', !matches);
    field.querySelectorAll('input, select, textarea').forEach((el) => {
      el.disabled = !matches;
    });
  };

  const evaluateAll = () => {
    document.querySelectorAll(SELECTOR).forEach(evaluate);
  };

  const init = () => {
    evaluateAll();
    document.addEventListener('change', evaluateAll, { passive: true });
    document.addEventListener('input', evaluateAll, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
